import logo from "../../images/logo.svg";

export default function Logo() {
  return <img src={logo} alt="logo" style={{ height: 140, width: 140 }} />;
}
